import http from '../interceptors/Intercepter';

export const updateSystemUserSettings = async (username, systemUserVOToUpdate) => {
  try {
    const { data } = await http.put('/api/systemUser/updateSettings', { username, systemUserVOToUpdate });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
